<template>
  <el-form
    :model="editForm"
    ref="editForm"
    label-width="100px"
    :hide-required-asterisk="false"
  >
    <el-row>
      <el-col :span="24">
        <el-tabs v-model="activeEditor" @tab-click="handleClickTabs">
          <el-tab-pane label="详细描述" name="0">
            <span><div id="wangEditor"></div></span>
          </el-tab-pane>
          <el-tab-pane label="解决方案" name="1">
            <span><div id="wangEditor2"></div></span>
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col style="margin-top: 15px">
        <el-form-item label="关闭是否通过" prop="isClose">
          <el-radio-group v-model="editForm.isClose">
            <el-radio label="1">通过</el-radio>
            <el-radio label="0">不通过</el-radio>
          </el-radio-group>
          <span style="color: #d9001b; margin-left: 30px; vertical-align: sub"
            ><img src="@/img/warning.svg" alt="" />
            问题关闭不通过，将重新激活</span
          >
        </el-form-item>
        <div v-show="editForm.isClose == 0">
          <div id="wangEditor3"></div>
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
import { mapGetters } from "vuex";
import wangEditor from "wangeditor";
import {
  getQuestionDetail,
  closeQuestion,
  saveComment,
} from "@/api/question.js";
export default {
  computed: {
    ...mapGetters(["deptUser", "question"]),
  },
  props: ["mxParams"],
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },

      editForm: {
        title: null,
        status: null,
        sort: null,
        questionLevel: null,
        line: null,
        xmbh: null,
        productVersion: null,
        module: null,
        influenceVersion: null,
        designee: null,
        content: null,
        finishTime: "",
        planTime: null,
        detail: null,
        jjfa: null,
        fileIds: null,
        designeeName: null,
        pinglun: [],
        isClose: "1",
      },
      activeEditor: "0",
      parentDialog: false,
    };
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.getData();
  },
  mounted() {
    let editor = new wangEditor(`#wangEditor`);
    let editor2 = new wangEditor(`#wangEditor2`);
    let editor3 = new wangEditor(`#wangEditor3`);
    editor = this.editorConfig(editor);
    editor2 = this.editorConfig(editor2);
    editor3 = this.editorConfig(editor3);

    // 创建编辑器
    this.editor = editor;
    this.editor2 = editor2;
    this.editor3 = editor3;
  },
  methods: {
    getData() {
      getQuestionDetail({ id: this.mxParams.id }).then((res) => {
        if (res.code == 0) {
          this.editForm = res.data;
          this.editForm.isClose = "1";
          this.editor.txt.html(this.editForm.detail);
          this.editor2.txt.html(this.editForm.jjfa);
          this.editor.disable();
          this.editor2.disable();
        }
      });
    },
    editorConfig(editor, height) {
      editor.config.placeholder = "请输入内容";
      editor.config.height = height ? height : 300;
      editor.config.uploadImgMaxSize = 10 * 1024 * 1024; //图片大小10M
      editor.config.uploadImgMaxLength = 1;
      editor.config.uploadFileName = "file"; //上传参数 自定义
      editor.config.uploadImgTimeout = 60000; //60s
      editor.config.uploadImgServer = window.g.apiUrl + "/system/uploadPicFile";
      editor.config.uploadImgHeaders = {
        "x-token": localStorage.getItem("token"), // 设置请求头
      };
      editor.config.uploadImgHooks = {
        //监听
        timeout: function (xhr, editor) {
          this.$message.error("上传图片超时！");
        },
        customInsert: function (insertImg, result, editor) {
          if (result.code == 0) {
            var url = result.msg;
            insertImg(url);
          }
        },
      };
      editor.config.excludeMenus = ["video", "link", "code"];

      editor.create();
      return editor;
    },

    saveForm() {
      const params = {
        ...this.editForm,
      };
      if (this.editForm.isClose == 0) {
        this.handleAddComment();
      }
      closeQuestion(params).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$store.dispatch(
            "question/fetchQuestionListAction",
            this.question.questionList.params
          );
          this.$emit("giveFather", this.parentDialog);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAddComment() {
      const params = {
        id: this.mxParams.id,
        status: this.editForm.status,
        content: this.editor3.txt.html(),
      };
      if (!params.content) {
        return;
      }
      saveComment(params).then((res) => {
        if (res.code == 0) {
          // this.$message.success(res.msg);
          this.editor3.txt.html("");
        }
      });
    },
    giveFather() {
      this.parentDialog = false;
    },

    handleClickTabs(e) {
      this.activeEditor = e.index;
    },
  },
};
</script>
<style lang="less" scoped>
.star {
  position: absolute;
  top: 13px;
  color: #f56c6c;
  left: 40px;
}
.r {
  margin: 0 10px;
  .r_title {
    text-align: center;
    line-height: 40px;
    border-bottom: 2px solid #e4e7ed;
    box-sizing: border-box;
    height: 40px;
    margin-bottom: 15px;
  }
}
.zpsm-comment-item {
  margin-top: 15px;
  .top {
    display: flex;
    line-height: 30px;
    font-weight: bold;
    font-size: 15px;
    > div {
      margin-right: 15px;
    }
    > div:nth-of-type(1) {
      background-color: #8080ff;
      color: #fff;
      height: 30px;
      line-height: 30px;
      width: 30px;
      text-align: center;
      border-radius: 50%;
    }
  }
  .middle {
    line-height: 20px;
    color: #555;
    padding-left: 45px;
    margin: 10px 0;
  }
  .bottom {
    font-size: 12px;
    padding-left: 45px;
    color: #7f7f7f;
  }
}
</style>